<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-producto-liquido-export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Generar listado Producto Liquido
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="nombre" class="col-md-5">Nombre</label>
                    <input
                      type="text"
                      id="nombre"
                      v-model="filtros.nombre"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="codigo" class="col-md-5">codigo</label>
                    <input
                      type="text"
                      id="codigo"
                      v-model="filtros.codigo"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="api" class="col-md-5">Api</label>
                    <input
                      type="number"
                      id="api"
                      v-model="filtros.api"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="bsw" class="col-md-5">BSW</label>
                    <input
                      type="number"
                      id="bsw"
                      v-model="filtros.bsw"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="azufre" class="col-md-5"> Azufre</label>
                    <input
                      type="number"
                      id="azufre"
                      v-model="filtros.azufre"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="sitio_id" class="col-md-5">Sitio</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="sitio"
                      placeholder="Sitios"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.sitios"
                      :filterable="true"
                      @input="getSelectSitios()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="promedio_cargue" class="col-md-5"
                      >Promedio de Cargue</label
                    >
                    <input
                      type="number"
                      id="promedio_cargue"
                      v-model="filtros.promedio_cargue"
                      class="col-md-7"
                    />
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre1"
                              v-model="form.nombre"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombre1"
                              >Nombre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="codigo1"
                              v-model="form.codigo"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="codigo1"
                              >Codigo</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="api1"
                              v-model="form.api"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="api1"
                              >Api</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="bsw1"
                              v-model="form.bsw"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="bsw1"
                              >BSW</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="azufre1"
                              v-model="form.azufre"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="azufre1"
                              >azufre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="sitio_id"
                              v-model="form.sitio_id"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="sitio_id"
                              >Sitio</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="promedio_cargue1"
                              v-model="form.promedio_cargue"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="promedio_cargue1"
                              >Promedio de Cargue</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  name: "ProductoLiquidoExport", //llegada tambien
  components: { vSelect },
  data() {
    return {
      sitio: null,
      form: {
        nombre: true,
        codigo: true,
        api: true,
        bsw: true,
        azufre: true,
        sitio_id: true,
        promedio_cargue: true,
      },
      filtros: {
        nombre: null,
        codigo: null,
        api: null,
        bsw: null,
        azufre: null,
        sitio_id: null,
        promedio_cargue: null,
      },
      listasForms: {
        sitios: [],
      },
    };
  },

  methods: {
    getSelectSitios() {
      this.filtros.sitio = {};
      this.filtros.sitio_id = null;
      if (this.sitio) {
        this.filtros.sitio = this.sitio;
        this.filtros.sitio_id = this.sitio.id;
      }
    },
    async getSitios() {
      await axios.get("api/admin/sitios/lista").then((response) => {
        this.listasForms.sitios = response.data;
      });
    },
    generarListadoExcel() {
      this.$parent.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/Productos/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },
  },

  async mounted() {
    await this.getSitios();
    this.cargando = true;
    this.cargando = false;
  },
};
</script>
